import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
import { Draggable } from "gsap/Draggable";
import * as Tone from 'tone';



// Svg
// https://parceljs.org/languages/svg/#inlining-as-a-string
import playSvg from 'bundle-text:../../svg/play.svg';
import circleControlSvg from 'bundle-text:../../svg/circleControlTwo.svg';
// import handSvg from 'bundle-text:../../svg/hand_c.svg';
// CSS
// import '../../styles/components/hand.scss';


// Ready
document.addEventListener('DOMContentLoaded', function () {



    if (!hasTouch()) document.body.className += ' hasHover'
    function watchForHover() {
        // lastTouchTime is used for ignoring emulated mousemove events
        let lastTouchTime = 0

        function enableHover() {
            if (new Date() - lastTouchTime < 500) return
            document.body.classList.add('hasHover')
        }

        function disableHover() {
            document.body.classList.remove('hasHover')
        }

        function updateLastTouchTime() {
            lastTouchTime = new Date()
        }

        document.addEventListener('touchstart', updateLastTouchTime, true)
        document.addEventListener('touchstart', disableHover, true)
        document.addEventListener('mousemove', enableHover, true)

        enableHover()
    }

    watchForHover();
    // 

    function hasTouch() {
        return 'ontouchstart' in document.documentElement
            || navigator.maxTouchPoints > 0
            || navigator.msMaxTouchPoints > 0;
    }

    if (hasTouch()) { // remove all the :hover stylesheets
        try { // prevent exception on browsers not supporting DOM styleSheets properly
            for (var si in document.styleSheets) {
                var styleSheet = document.styleSheets[si];
                if (!styleSheet.rules) continue;

                for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
                    if (!styleSheet.rules[ri].selectorText) continue;

                    if (styleSheet.rules[ri].selectorText.match(':hover')) {
                        styleSheet.deleteRule(ri);
                    }
                }
            }
        } catch (ex) { }
    }


    gsap.registerPlugin(CustomEase, Draggable);



    // Inject Control Span Svg
    const controlSpans = document.querySelectorAll('.controlSpans span');
    controlSpans.forEach(function (controlSpan) {
        controlSpan.innerHTML = circleControlSvg;
    });







    // Hand Song
    // const soundURL = require("url:../../audio/P_4_01.m4a");
    // const soundURL = require("url:../../audio/TTT.m4a");
    // const soundURL = require("url:../../audio/m_gong.mp3");
    // Sound URLs
    const soundURL1 = require("url:../../audio/909BD_T1A1D11V1_Orig.wav");
    const soundURL2 = require("url:../../audio/909BD_T1A1D11V1_Orig.wav"); // New sound file

    // Set up audio processing chain FIRST
    const reverb = new Tone.Reverb({
        decay: 2,
        wet: 0.15  // Reduced wet signal
    }).toDestination();

    const delay = new Tone.FeedbackDelay({
        delayTime: 0.25,  // Reduced delay time
        feedback: 0.1     // Reduced feedback
    }).connect(reverb);

    // Add limiter and compressor for smoother audio
    const limiter = new Tone.Limiter(-12).toDestination();  // More aggressive limiting
    const compressor = new Tone.Compressor({
        threshold: -24,
        ratio: 12,
        attack: 0.003,
        release: 0.25
    }).connect(limiter);

    // Shared gain node with reduced gain
    const sharedGainNode = new Tone.Gain(0.2)  // Further reduced gain
        .connect(compressor)
        .connect(delay)    // Changed routing order
        .connect(reverb)   // Reverb last in chain
        .toDestination();

    // THEN set up the players and animations
    // Players for Each Track, connected to shared effects
    const player1 = new Tone.Player({
        url: soundURL1,
        loop: true,
        // onload: () => startDotAnimation(".--left .dot", player1.buffer.duration) // Start animation when loaded
        onload: () => initDotAnimation(".--left .dot")
    }).connect(sharedGainNode);

    const player2 = new Tone.Player({
        url: soundURL2,
        loop: true,
        // onload: () => startDotAnimation(".--right .dot", player2.buffer.duration) // Start animation when loaded
        onload: () => initDotAnimation(".--right .dot")
    }).connect(sharedGainNode);

    // Function to set up the dot animation (hidden initially)
    // Function to create a persistent animation timeline for the dot
    function createDotTimeline(dotSelector) {
        const timeline = gsap.timeline({ repeat: -1, paused: true });
        timeline.to(dotSelector, { rotate: 360, duration: 2, ease: "none" });
        return timeline;
    }

    // Initialize timelines for each dot
    const leftDotTimeline = createDotTimeline(".--left .dot");
    const rightDotTimeline = createDotTimeline(".--right .dot");


    // player.volume.value = 2;

    // Connect the player to the delay effect
    // attackGain1.connect(delay);

    // Set the gain to 1 over the attack time (in seconds)
    // attackGain1.gain.setTargetAtTime(1, Tone.now(), 0.2); // Adjust attack time as needed



    const crusher = new Tone.BitCrusher(4).toDestination();

    gsap.set(".l00k, .__hand", { backgroundColor: "#ffffff" });

    // Track One Animation
    const l00kAnimation = gsap.timeline({ paused: true })
        // .to(".l00k", {
        //     rotate: -0.075,
        //     scale: 1.0025,
        //     duration: 0.125,
        //     ease: "cubic-bezier(1, -0.55, -0.27, 3)"
        // })
        // .to(".l00k", {
        //     scale: 1,
        //     rotate: 0,
        //     duration: 0.2,
        //     ease: "cubic-bezier(0.68, 1, -0.27, 3)"
        // })
        .to("#hm__flash", {
            opacity: 0.1,
            scaleX: 1,
            scaleY: 1,
            ease: "power4.inOut",
            duration: 0.0675,
        }, 0)
        .to(".l00k__author", {
            opacity: 0.8,
            duration: 0.0675,
            yoyo: true,
            repeat: 1,
        }, 0)
        // .to(".controlSpans", {
        //     scaleX: 1.005,
        //     scaleY: 1.05,
        //     yoyo: true,
        //     repeat: 1,
        //     duration: 0.1,
        // }, 0)
        .to("#hm__flash", {
            opacity: 0,
            scaleX: 1.1,
            scaleY: 1.05,
            ease: "power4.out",
            transformOrigin: "center",
            duration: 0.125,
        })
        ;

    // Track Two Animation
    const handAnimation = gsap.timeline({ paused: true })
        // .to(".__hand", {
        //     rotate: 0.025,
        //     scale: 1.0025,
        //     duration: 0.2,
        //     ease: "power2.inOut"
        // })
        // .to(".__hand", {
        //     rotate: 0,
        //     scale: 1,
        //     duration: 0.2,
        //     ease: "cubic-bezier(1, -0.55, -0.27, 3)"
        // })
        .to(".l00k__author", {
            opacity: 0.8,
            duration: 0.0675,
            yoyo: true,
            repeat: 1,
        }, 0)
        .to("#hm__flash__2", {
            opacity: 0.1,
            scaleX: 1,
            scaleY: 1,
            ease: "power4.inOut",
            duration: 0.0675,
        }, 0)
        // .to(".controlSpans > span", {
        //     scaleX: 1.05,
        //     scaleY: 1.01,
        //     yoyo: true,
        //     repeat: 1,
        //     duration: 0.1,
        // }, 0)
        .to("#hm__flash__2", {
            opacity: 0,
            scaleX: 1.05,
            scaleY: 1.075,
            ease: "power4.out",
            transformOrigin: "center",
            duration: 0.125,
        });

    // Keep track of animation intervals
    let trackOneInterval;
    let trackTwoInterval;

    function toggleAudio(buttonId, player, dotSelector) {
        const button = document.getElementById(buttonId);
        const dotTimeline = createDotTimeline(dotSelector);
        
        button.onclick = function () {
            const isChecked = button.getAttribute("aria-checked") === "true";
            button.setAttribute("aria-checked", !isChecked ? "true" : "false");

            if (!isChecked) {
                player.start();
                dotTimeline.play();  // Start the continuous dot rotation
                
                if (buttonId === "theSmallSwitch1") {
                    console.log("Track 1 Started, Duration:", player1.buffer.duration);
                    
                    function animateTrackOne() {
                        l00kAnimation.restart();
                        trackOneInterval = setTimeout(animateTrackOne, player1.buffer.duration * 1000);
                    }
                    animateTrackOne();
                }
                
                if (buttonId === "theSmallSwitch2") {
                    console.log("Track 2 Started, Duration:", player2.buffer.duration);
                    
                    function animateTrackTwo() {
                        handAnimation.restart();
                        trackTwoInterval = setTimeout(animateTrackTwo, player2.buffer.duration * 1000);
                    }
                    animateTrackTwo();
                }
            } else {
                player.stop();
                dotTimeline.pause(0);  // Stop and reset the dot rotation
                
                if (buttonId === "theSmallSwitch1") {
                    clearTimeout(trackOneInterval);
                    l00kAnimation.pause(0);
                }
                if (buttonId === "theSmallSwitch2") {
                    clearTimeout(trackTwoInterval);
                    handAnimation.pause(0);
                }
            }
        };
    }

    // Initialize toggle for both audio tracks
    toggleAudio("theSmallSwitch1", player1, ".--left .dot");
    toggleAudio("theSmallSwitch2", player2, ".--right .dot");

    // /// Video BGs
    // const videoContainer = document.getElementById('hm__video');
    // let video = document.createElement('video');
    // video.setAttribute('loop', true);
    // video.setAttribute('disablePictureInPicture', true);

    // video.muted = "muted";
    // video.pause();
    // videoContainer.appendChild(video);
    // video.src = new URL('../../video/Comp___1--sm.mp4', import.meta.url);

    // video.setAttribute('playsinline', true);
    // if (video.hasAttribute("controls")) {
    //     video.removeAttribute("controls")
    // };
    // video.addEventListener("contextmenu", function (e) { e.preventDefault(); e.stopPropagation(); }, false);


    // /// Video Top
    // const videoTopContainer = document.getElementById('hm__video__top');
    // let videoTop = document.createElement('video');
    // videoTop.setAttribute('loop', true);
    // videoTop.pause();
    // videoTop.muted = "muted";
    // videoTopContainer.appendChild(videoTop);
    // videoTop.src = new URL('../../video/MAH03652_1_1_1_1_2.mp4', import.meta.url);
    // videoTop.setAttribute('playsinline', true);
    // if (videoTop.hasAttribute("controls")) {
    //     videoTop.removeAttribute("controls")
    // };
    // videoTop.addEventListener("contextmenu", function (e) { e.preventDefault(); e.stopPropagation(); }, false);

    gsap.set(".ui-switch .dot", { opacity: 1, transformOrigin: "center" });
    gsap.set("#hm__video", { scale: 1 });

    // Initialize gongSynth outside of any function to make it globally accessible
    const gongGain = new Tone.Gain(0.05).toDestination(); // Lower volume for gongSynth
    const gongSynth = new Tone.Synth({
        oscillator: { type: 'pulse' },
        envelope: {
            attack: 1.125,
            decay: 21,
            sustain: 1,
            release: 1111
        }
    }).connect(gongGain); // Route through its own gain node

    // Gong Sound Trigger
    function playGongSound() {
        // Trigger the gong sound on click event
        gongSynth.triggerAttackRelease("A#1", "4n");
    }

    // Initialize gongSynthTwo as a noise generator for static effect
    const gongNoiseGain = new Tone.Gain(1.5).toDestination(); // Set to a lower level
    const gongSynthTwo = new Tone.Noise("brown").connect(gongNoiseGain); // Route through its own gain node
    gongSynthTwo.volume.value = -35; // Further adjust the volume level for the static effect

    // Set up a simple envelope for triggering noise
    const noiseEnvelope = new Tone.AmplitudeEnvelope({
        attack: 0.5,
        decay: 0.9,
        sustain: 0.5,
        release: 1
    }).connect(gongNoiseGain); // Route through its own gain node

    // Connect noise to envelope for triggering
    gongSynthTwo.connect(noiseEnvelope);

    // gongGainNode.gain.value = 1; // Fine-tune this value if needed


    let isGongPlaying = false;

    let itemPeel = document.getElementsByClassName("item__peel")[0];







    // Circle Control
    var clipper = clipAtRadius(140, 0, 0);
    gsap.set(".circleControl__dot", { transformOrigin: "center", scale: 0.6 });
    // gsap.set(".circleControl__bg", { transformOrigin: "center" });

    const pitchRange = { min: 40, max: 80 }; // MIDI note values
    const crusherRange = { min: 1, max: 8 }; // Crusher effect bit depth values


    // Control Intro ( affordance signal )
    gsap.set("g.arrow-group line", { transformOrigin: "center", autoAlpha: 0 });

    gsap.to("g.arrow-group line:nth-of-type(1), g.arrow-group line:nth-of-type(3)", {
        autoAlpha: 1,
        transformOrigin: "center",
        yoyo: true,
        repeat: 1,
        repeatDelay: 0.25,
        strokeDashoffset: 0,
        duration: 1,
        delay: 0.5,
        ease: "power4.in",
    });
    gsap.to("g.arrow-group line:nth-of-type(2), g.arrow-group line:nth-of-type(4)", {
        autoAlpha: 1,
        transformOrigin: "center",
        yoyo: true,
        repeat: 1,
        repeatDelay: 0.25,
        strokeDashoffset: 10,
        duration: 1.5,
        ease: "power4.in",
    });


    Draggable.create(".__player .circleControl__dotGroup", {
        liveSnap: {
            points: clipper,
        },
        allowContextMenu: false,
        inertia: true,
        onClick: function () {
            gongSynth.triggerAttackRelease("C#2", "2n");
            gsap.to(".__player .circleControl__dot", {
                scale: 0.95,
                yoyo: true,
                repeat: 1,
                duration: 0.125,
                ease: "power4.in",
            });
            gsap.to("#vision__two .circleControl__control", {
                scale: 0.8,
                strokeWidth: "1.25em",
                transformOrigin: "center",
                yoyo: true,
                repeat: 1,
                duration: 0.1,
            });
        },
        onDragStart: function () {
            playGongSound();
            gsap.to("g.arrow-group", {
                autoAlpha: 0,
                duration: 0,
            });
            gsap.to(".__player .circleControl__dot", {
                scale: 0.6,
                duration: 0.5,
            });
            gsap.to("#vision__two .circleControl__control", {
                scale: 0.8,
                transformOrigin: "center",
                strokeWidth: "1.5em",
                duration: 0.125,
            });
            
        },
        onDrag: function () {
            if (!isGongPlaying) {
                gongSynthTwo.start(); // Start the noise generator
                isGongPlaying = true;
            }
            // Trigger the envelope for a burst of static noise
            noiseEnvelope.triggerAttackRelease(0.05); // Adjust duration for short bursts of static

            // Smooth parameter changes with rampTo
            const xMappedDelay = Math.max(0, Math.min(1, mapRange(this.x, -200, 200, 0, 1)));
            const yMappedReverb = Math.max(0, Math.min(4.99, mapRange(this.y, -200, 200, 0, 5)));
            
            // Use rampTo for smoother transitions
            delay.delayTime.rampTo(xMappedDelay, 0.1); // 100ms ramp
            reverb.decay = yMappedReverb;
            
            // Smooth the crusher transitions
            const crushValue = mapRange(this.y, -200, 200, crusherRange.min, crusherRange.max);
            crusher.bits = Math.round(crushValue); // Round to prevent in-between values
            
            // Smooth frequency changes for gongSynth
            const pitch = mapRange(this.x, -200, 200, pitchRange.min, pitchRange.max);
            gongSynth.frequency.rampTo(Tone.Midi(pitch).toFrequency(), 0.05); // 50ms ramp
        },

        onDragEnd: function () {
            gsap.to("#vision__two .circleControl__dot", {
                scale: 0.6,
                duration: 0.15,
            });
            
            gsap.to("#vision__two .circleControl__control", {
                scale: 1,
                transformOrigin: "center",
                strokeWidth: "0em",
                duration: 0.125,
            });
            noiseEnvelope.triggerRelease();
            setTimeout(() => gongSynthTwo.stop(), noiseEnvelope.release * 100); // Stops the noise generator after the fade-out
            isGongPlaying = false;


        },
        // onDragEnd: function () {
        //   gsap.to(".circleControl__dot", { scale: 3, duration: 0.1});
        // },
    });

    function mapRange(value, inMin, inMax, outMin, outMax) {
        return ((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
    }

    function clipAtRadius(radius, offsetX, offsetY) {
        return function (point) {
            let x = point.x - offsetX,
                y = point.y - offsetY,
                length = Math.sqrt(x * x + y * y),
                angle;
            if (length > radius) {
                angle = Math.atan2(y, x);
                point.x = radius * Math.cos(angle);
                point.y = radius * Math.sin(angle);
            }
            return point;
        };
    }
}, false);





